import styled from "styled-components";
import { FLEX } from "styles/flex";
import { COLORS, LIGHT_THEME_COLORS, MAP_STATUS_COLORS } from "styles/colors";
import { calcRem } from "styles/theme";
import VideoThumbnail from "components/atoms/image/thumbnail/VideoThumbnail";
import {
  DashboardAlertData,
  MapSearchData,
  MarkerDataSystem,
} from "api/interfaces/dashboardInterface.interface";
import { BsFillExclamationCircleFill } from "react-icons/bs";
import { convertType } from "utils/functions";
import WebAppLink from "components/blocks/link/WebAppLink";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import { useAppSelector } from "redux/hooks";
import { AssigneeInfo } from "./listInfoItem/AssigneeInfo";
import * as mediaQuery from "components/MediaQuery";
import { MouseEventHandler } from "react";
interface InfoViewProps {
  system: MarkerDataSystem;
  onClickMarkerAlert?: MouseEventHandler<HTMLDivElement>;
  cloudStatus: boolean;
  closeInfoWindow?: () => void;
  onSelectRecorder?: (rec: MapSearchData) => void;
}

export default function RecorderInfoView(props: InfoViewProps): JSX.Element {
  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );
  const isMobile = mediaQuery.useIsMobile();
  const total: DashboardAlertData[] = [
    ...props.system.alerts,
    // ...props.system.assign,
    ...props.system.critical,
    ...props.system.warnings,
  ];

  return (
    <Wrapper
      onClick={props.onClickMarkerAlert}
      onMouseLeave={() => {
        if(isMobile) return;
        props.closeInfoWindow && props.closeInfoWindow();
      }}
      data-testid="dashboard-map-info-view-wrapper-click-marker-alert"
    >
      <RecorderName>
        <div className="recorder-text type">
          {convertType(props.system)}
          <div className="web-app-link-wrapper">
            <WebAppLink
              {...props.system}
              accountId={selectedAccount.accountId}
              cloudStatus={props.cloudStatus}
            />
          </div>
        </div>
        <div className="recorder-text name">
          {props.system.mergedSystemName}
        </div>
        {props.system.type === "Spectrum" && (
          <div className="merged-name">{props.system.name}</div>
        )}
      </RecorderName>
      <RecorderImage>
        <VideoThumbnail
          videoLoss={false}
          thumbnailUrl={props.system.thumbnail}
        />
      </RecorderImage>
      <AlertList>
        {props.system.alerts.length > 0 && (
          <AlertStatus status="ALERT">
            <BsFillExclamationCircleFill
              size={13}
              color={MAP_STATUS_COLORS.ALERT}
            />

            {props.system.alerts.length}
            <span>Alert{props.system.alerts.length > 1 && "s"}</span>
          </AlertStatus>
        )}

        {props.system.critical.length > 0 && (
          <AlertStatus status="CRITICAL">
            <BsFillExclamationCircleFill
              size={13}
              color={MAP_STATUS_COLORS.CRITICAL}
            />

            {props.system.critical.length}
            <span>Critical{props.system.critical.length > 1 && "s"}</span>
          </AlertStatus>
        )}

        {props.system.warnings.length > 0 && (
          <AlertStatus status="WARNING">
            <BsFillExclamationCircleFill
              size={13}
              color={MAP_STATUS_COLORS.WARNING}
            />

            {props.system.warnings.length}
            <span>Warning{props.system.warnings.length > 1 && "s"}</span>
          </AlertStatus>
        )}

        {selectedAccount.isEnabled && (
          <>
            {(total.length === undefined || total.length === 0) && (
              <AlertStatus status="RESOLVED">No Alerts</AlertStatus>
            )}

            <AssigneeInfo recorder={props.system} />
          </>
        )}
      </AlertList>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  background-color: ${({ theme }) =>
    theme.value === "light" ? LIGHT_THEME_COLORS.FILTERITEM : COLORS.PRIMARY1};
  border-radius: 8px;
  padding: 14px;
  ${FLEX.FlexStartStart};
  flex-direction: column;
  gap: 6px;
  width: 200px;
`;

const RecorderName = styled.div`
  width: 100%;
  ${FLEX.FlexStartStart};
  flex-direction: column;
  gap: 3px;

  line-height: ${calcRem(16)};

  .recorder-text {
    width: 100%;
    /* overflow: hidden; */
    /* text-overflow: ellipsis; */
    font-size: ${calcRem(13)};
    font-weight: 500;
    color: ${({ theme }) => theme.COLORS.WHITE};
  }
  .name {
    font-size: ${calcRem(17)};
    white-space: pre-wrap;
    overflow-wrap: break-word;
  }

  .type {
    color: ${({ theme }) => theme.COLORS.SELECTED};
    ${FLEX.FlexBetweenCenter};

    .web-app-link {
      font-size: ${calcRem(12)};
    }
  }

  .merged-name {
    font-size: ${calcRem(15)};
    color: ${({ theme }) => theme.COLORS.WHITE};
  }
`;

const RecorderImage = styled.div`
  width: 100%;
`;

const AlertList = styled.ul`
  ${FLEX.FlexStartCenter};
  column-gap: 8px;
  row-gap: 4px;
  white-space: nowrap;
  flex-wrap: wrap;
`;
const AlertStatus = styled.li<{ status: string }>`
  ${FLEX.FlexStartCenter};
  gap: 3px;
  color: ${({ status }) => MAP_STATUS_COLORS[status]};
  font-size: ${calcRem(13)};
  flex: 1;
  span {
    margin-left: -1px;
  }
`;
